import { render, staticRenderFns } from "./upDataPassword.vue?vue&type=template&id=429abdc5&"
import script from "./upDataPassword.vue?vue&type=script&lang=js&"
export * from "./upDataPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports